module.exports = __webpack_public_path__ + "media/applicants/wsj-40e0352e.png";